"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabs = void 0;
exports.tabs = {
    tabs_map: "На карте",
    tabs_list: "Списком",
    tabs_news: "Новости",
    tabs_profile: "Профиль",
};
//# sourceMappingURL=tabs.js.map